/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemAudioTrackFromJSON(json) {
    return WallItemAudioTrackFromJSONTyped(json, false);
}
export function WallItemAudioTrackFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'active': !exists(json, 'active') ? undefined : json['active'],
        'backgrounded': !exists(json, 'backgrounded') ? undefined : json['backgrounded'],
    };
}
export function WallItemAudioTrackToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'active': value.active,
        'backgrounded': value.backgrounded,
    };
}
//# sourceMappingURL=WallItemAudioTrack.js.map